/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SetQaCheckResultEntry } from '../../models/set-qa-check-result-entry';

export interface SetAllQaChecksForProducedMaterial$Params {
  workCenterId: number;
  producedMaterialId: number;
      body: SetQaCheckResultEntry
}

export function setAllQaChecksForProducedMaterial(http: HttpClient, rootUrl: string, params: SetAllQaChecksForProducedMaterial$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, setAllQaChecksForProducedMaterial.PATH, 'post');
  if (params) {
    rb.path('workCenterId', params.workCenterId, {});
    rb.path('producedMaterialId', params.producedMaterialId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

setAllQaChecksForProducedMaterial.PATH = '/api/v1/QaCheck/{workCenterId}/SetAllQaChecksForProducedMaterial/{producedMaterialId}';
